// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo img[data-v-6f535954]{height:90px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Auth/AppLogo.vue"],"names":[],"mappings":"AAEQ,2BACI,WADZ","sourcesContent":["\r\n    .logo {        \r\n        img{\r\n            height: 90px;\r\n        }\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
